import { memo } from 'react';

import { Helmet } from 'react-helmet-async';

import config, { APP_STAGE_PRODUCTION } from '@config';

const Robots = memo(() => {
  return config.APP_STAGE !== APP_STAGE_PRODUCTION ? (
    <Helmet>
      <meta key="robots" name="robots" content="noindex,follow" />
      <meta key="googlebot" name="googlebot" content="noindex,follow" />
    </Helmet>
  ) : null;
});

export { Robots };
